
import {
    maskitoCaretGuard,
    maskitoEventHandler,
    maskitoNumberOptionsGenerator
} from '@maskito/kit';

/* Mask for Phone (Russian format) */
export function phoneMask(input) {
    let phoneInput = input;

    let getInputNumbersValue = function (input) {
        // Возвращаем только цифры из введенного значения
        return input.value.replace(/\D/g, '');
    }

    let onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData('Text');
            if (/\D/g.test(pastedText)) {
                // При вставке некорректного символа оставляем только цифры
                input.value = inputNumbersValue;
                return;
            }
        }
    }

    let onPhoneInput = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return input.value = "";
        }

        if (input.value.length != selectionStart) {
            // Если редактируем не в конце поля
            if (e.data && /\D/g.test(e.data)) {
                // Если вводим не числовой символ
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols = (inputNumbersValue[0] == "8") ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += '(' + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ') ' + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += '-' + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += '-' + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = '+' + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
    }

    let onPhoneKeyDown = function (e) {
        // Удаление последнего символа очищает поле
        let inputValue = e.target.value.replace(/\D/g, '');
        if (e.keyCode == 8 && inputValue.length == 1) {
            e.target.value = "";
        }
    }

    let onPhoneFocus = function (e) {
        let input = e.target;
        if (input.value === "") {
            input.value = "+7 "; // Устанавливаем начальное значение
            input.setSelectionRange(3, 3); // Устанавливаем курсор после +7
        }
    }

    phoneInput.addEventListener('keydown', onPhoneKeyDown);
    phoneInput.addEventListener('input', onPhoneInput, false);
    phoneInput.addEventListener('paste', onPhonePaste, false);
    phoneInput.addEventListener('focus', onPhoneFocus); // Добавляем обработчик focus
}

/* https://maskito.dev/kit/date */
/* Mask for Year and Money */
export function getOptions(option, postfix) {

    /* Year */
    if (option === 'year') {
        const {plugins, ...numberOptions} = maskitoNumberOptionsGenerator({
            min: 2000,
            max: 2050,
            postfix,
        });
 
        return {
            ...numberOptions,
            plugins: [
                ...plugins,
                maskitoCaretGuard((value) => [0, value.length - 1]),
                maskitoEventHandler('blur', (element) => {
                    if (element.value === postfix) {
                        maskitoUpdateElement(element, `0${postfix}`);
                    }
                }),
            ],
        }
    }

    /* Money */
    if (option === 'money') {
        const {plugins, ...numberOptions} = maskitoNumberOptionsGenerator({
            min: 0,
            max: 10000000,
            postfix,
        });
        return {
            ...numberOptions,
            plugins: [
                ...plugins,
                maskitoCaretGuard((value) => [0, value.length - 1]),
                maskitoEventHandler('blur', (element) => {
                    if (element.value === postfix) {
                        maskitoUpdateElement(element, `0${postfix}`);
                    }
                }),
            ],
        };
    }
}




